export class User {
    id?: number
    name?: string
    title?: string
    userName?: string
    picture?: string
    role?: number
    active?: number
    password?: string
    companyId?: number
    public status?:boolean
}